import React from 'react';
import { useFormContext } from 'react-hook-form';
import { PdsLoader } from '@pine-ds/react';

import CheckoutStripeElements from 'apps/commerce/common/checkout/components/CheckoutStripeElements';
import { CheckoutConfigData } from 'apps/commerce/embedded_checkout_preview/types';
import useEmbeddedCheckout from 'apps/commerce/embedded_checkout/hooks/useEmbeddedCheckout';
import EmbeddedCheckoutForm from './components/EmbeddedCheckoutForm';

interface Props {
  offerToken: string;
  checkoutConfig: CheckoutConfigData;
}

// eslint-disable-next-line no-unused-vars
import i18next from '../translations/i18n';

/**
 * Embedded Checkout component for use in the popup checkout context
 * does not include sage context or react-hook-form context, as they
 * are provided by PopupCheckout.jsx
 */
const EmbeddedCheckout = ({ offerToken, checkoutConfig }: Props) => {
  const { getValues } = useFormContext();
  const {
    stripe,
    attemptReloadWithCardsOnly,
    currency,
    paymentMethods,
    additionalPaymentMethods,
    vendorAccountId,
  } = getValues();

  const checkoutData = useEmbeddedCheckout(offerToken);

  const renderCheckoutForm = () => {
    if (!checkoutData?.offerDataLoaded) {
      return <PdsLoader />;
    }
    return <EmbeddedCheckoutForm checkoutConfig={checkoutConfig} checkoutData={checkoutData} />;
  };

  return (
    <CheckoutStripeElements
      attemptReloadWithCardsOnly={attemptReloadWithCardsOnly}
      stripe={stripe}
      amountPriceInCents={checkoutData?.amountPriceInCents}
      currency={currency}
      paymentMethods={paymentMethods}
      additionalPaymentMethods={additionalPaymentMethods}
      vendorAccountId={vendorAccountId}
    >
      {renderCheckoutForm()}
    </CheckoutStripeElements>
  );
};

export default EmbeddedCheckout;
